@let isErrorOccurred = errorNotificationService.isErrorOccurred$ | async;

<mm-navigation [activeNavigation]="'badges'"></mm-navigation>
<div class="micromate-learn-component"
     [class.micromate-learn-component-dev-error]="isErrorOccurred !== null && isErrorOccurred !== undefined && isErrorOccurred === true">
    <div class="micromate-learn-context">
        <mm-badges
            [badgesData]="badges$"
            [darkMode]="false">
        </mm-badges>
    </div>

</div>

